export default __webpack_public_path__ + "static/media/14.7db6e80b.png";